import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import UICardGrid from 'UIComponents/card/UICardGrid';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The new card variant, originally designed for the API Overview page.
 * Eventually all cards will be migrated to the new card component, so please
 * use this for UX consistency.
 */
const CardsRow = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UICardGrid, Object.assign({}, props, {
    children: children
  }));
};
export default CardsRow;